import { Controller } from "@hotwired/stimulus"
import Highcharts from 'highcharts'
import HighchartsMoreFn from 'highcharts/highcharts-more'
import HighchartsAccessibilityFn from 'highcharts/modules/accessibility'

HighchartsMoreFn(Highcharts)
HighchartsAccessibilityFn(Highcharts)

// Connects to data-controller="spider-high-chart"
export default class extends Controller {
  static values = {
    data: Array,
    width: Number,
    height: Number
  }

  connect() {
    this.createSpiderWebChart();
  }

  // Create spider chart
  createSpiderWebChart(){
    const CHART_SHOW_HASH = {
      sharp: 'シャープレシオ',
      reward: '実質信託報酬',
      sellbank: '販売会社数',
      return: '利回り(リターン)',
      stdevy: '標準偏差',
      popular: '注目度'
    }
    this.chart = Highcharts.chart(this.element, {
      credits: {
        enabled: false
      },
      chart: {
        backgroundColor: 'transparent',
        polar: true,
        type: 'line',
        marginLeft: 0,
        // chart width and height is necessary because bg color position
        height: this.heightValue,
        width: this.widthValue
      },
      title: {
        text: ''
      },
      xAxis: {
        categories: Object.values(CHART_SHOW_HASH),
        visible: true,
        tickmarkPlacement: 'on',
        lineWidth: 0,
        gridLineWidth: 0,
        labels: {
          style: {
            fontFamily: "-apple-system,\'BlinkMacSystemFont\',\'Hiragino Kaku Gothic ProN\',\'Noto Sans CJK JP\',\'Noto Sans JP\',\'Noto Sans\',sans-serif",
            fontSize: '11px',
            fontWeight: 'bold',
            color: '#64748B'
          },
          distance: 15
        }
      },
      yAxis: {
        gridLineInterpolation: 'polygon',
        gridLineWidth: 0,
        lineWidth: 0,
        min: 0,
        max: 100, // same as legacy
        tickAmount: 3,
        labels: {
          enabled: false
        },
      },
      tooltip: {
        enabled: true,
        formatter: function () {
          var tooltip = ''
          tooltip = '<span style="font-size: 0.625rem">' + this.x + '</span><br>' +
                    '<span style="fill:' + this.color + '">● </span><span style="font-weight: bold">' + this.y + 'pt' + '</span></span>'
          return tooltip;
        }
      },
      legend: {
        enabled: false
      },
      pane: {
        size: '70%'
      },
      plotOptions: {
        series: {
          states: {
            hover: {
              enabled: true
            }
          }
        }
      },
      series: [{
        name: '値',
        data: this.dataValue,
        pointPlacement: 'on',
        lineWidth: 1,
        marker:{
          radius: 1.4,
        }
      }]
    });


    // Change chart bg color
    let colors = ["#CBD5E1", "#E2E8F0", "#F1F5F9", "#F8FAFC"];
    let parts = 6;
    let interval = 6;

    for(let i = 0; i < colors.length; i++) {
      let centerX = this.chart.plotLeft + this.chart.yAxis[0].center[0];
      let centerY = this.chart.plotTop + this.chart.yAxis[0].center[1];
      let axisLength = this.chart.yAxis[0].height - interval * i;
      let angleOffset = -Math.PI / 2;
      let angleSegment = Math.PI / (parts / 2);

      for(let j = 0; j < parts; j++) {
        let firstPointX = centerX + (axisLength * Math.cos(angleOffset + (angleSegment * j)));
        let firstPointY = centerY + (axisLength * Math.sin(angleOffset + (angleSegment * j)));

        let secondPointX = centerX + (axisLength * Math.cos(angleOffset + (angleSegment * (j + 1))));
        let secondPointY = centerY + (axisLength * Math.sin(angleOffset + (angleSegment * (j + 1))));
        
        this.chart.renderer.path([
          'M', centerX, centerY,
          'L', firstPointX, firstPointY,
          'L', secondPointX, secondPointY,
          'Z'
        ]).attr({
          fill: colors[i],
          'stroke-width': 1,
          'opacity': 1
        }).add();
      }
    }
  }
}
